import React, { useContext, useState } from 'react';
import { useMutation } from '@apollo/client';
import { AgFinancingCollateralAnalysisStatus, AgFinancingInput } from '@indigo-ag/schema';

import { CollateralUtil } from 'shared';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import { upsertFinancingAgFinancing } from 'features/brazil-grower/queries';
import { ToggleOnHold } from '../ToggleOnHold/ToggleOnHold';

export const ToggleOnHoldCollateralAnalysis: React.FunctionComponent = () => {
  /**
   * Finance Process Context
   */
  const { agFinance } = useContext(FinanceProcessContext);

  /**
   * State
   */
  const [isAnalysisOnHold, setIsAnalysisOnHold] = useState(
    agFinance?.phase2?.collateral?.status === AgFinancingCollateralAnalysisStatus.ON_HOLD
  );

  /**
   * Mutations
   */
  const [upsertFinancingAgFinancingFn] = useMutation(upsertFinancingAgFinancing);

  const toggleOnHoldCreditAnalysis = (decisionNotes: string) => {
    const newAgFinancingData: Partial<AgFinancingInput> = {
      id: agFinance?.id,
      phase2: {
        collateral: {
          status: CollateralUtil.isOnHold(agFinance?.phase2?.collateral?.status)
            ? AgFinancingCollateralAnalysisStatus.STARTED
            : AgFinancingCollateralAnalysisStatus.ON_HOLD,
          decisionNotes: decisionNotes
        }
      }
    };

    return upsertFinancingAgFinancingFn({
      variables: {
        data: newAgFinancingData
      }
    }).then(() => setIsAnalysisOnHold(!isAnalysisOnHold));
  };

  return (
    <ToggleOnHold
      visible={CollateralUtil.canOnHoldResume(agFinance?.phase2)}
      isOnHold={isAnalysisOnHold}
      onConfirmation={toggleOnHoldCreditAnalysis}
    />
  );
};
